import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';

function TermsOfService() {
  return (
    <Box sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <Paper elevation={0} sx={{ p: { xs: 3, md: 6 }, bgcolor: 'background.paper', borderRadius: 2 }}>
          <Typography variant="h3" component="h1" gutterBottom sx={{ color: '#580100', fontWeight: 600, mb: 4 }}>
            Terms of Service
          </Typography>

          <Typography paragraph sx={{ mb: 4 }}>
            These Terms of Service govern your access and use of the Andheri Court's Bar Association website. 
            By using this website, you agree to abide by the terms outlined below.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Acceptance of Terms
          </Typography>
          <Typography paragraph>
            By accessing our website, you confirm that you have read, understood, and agree to these Terms of Service. 
            If you do not agree, please discontinue the use of this website.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Permitted Use
          </Typography>
          <Typography paragraph>
            The website is intended for members of the Andheri Court's Bar Association and the general public seeking legal information or resources.
          </Typography>
          <Typography paragraph>
            Users must not engage in activities that:
          </Typography>
          <List sx={{ pl: 2 }}>
            <ListItem>
              <ListItemText primary="Breach applicable laws or regulations." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Disrupt the website's operations." />
            </ListItem>
            <ListItem>
              <ListItemText primary="Involve unauthorized access, hacking, or tampering." />
            </ListItem>
          </List>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Content Ownership
          </Typography>
          <Typography paragraph>
            All content, including but not limited to text, images, logos, and multimedia, is the intellectual property 
            of the Andheri Court's Bar Association. Unauthorized reproduction, distribution, or alteration of any 
            materials is prohibited.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Modification of Terms
          </Typography>
          <Typography paragraph>
            The association reserves the right to update or modify these Terms of Service at any time. Continued use 
            of the website signifies your acceptance of the revised terms.
          </Typography>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Disclaimers
          </Typography>
          <List sx={{ pl: 2 }}>
            <ListItem>
              <ListItemText 
                primary="Accuracy of Information" 
                secondary="While we strive to provide accurate and up-to-date information, we do not guarantee the completeness or reliability of content."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
            <ListItem>
              <ListItemText 
                primary="Limitation of Liability" 
                secondary="The association shall not be liable for any damages arising from the use or inability to use the website."
                primaryTypographyProps={{ fontWeight: 600 }}
              />
            </ListItem>
          </List>

          <Typography variant="h5" gutterBottom sx={{ color: '#580100', fontWeight: 600, mt: 4 }}>
            Termination
          </Typography>
          <Typography paragraph>
            We may terminate or restrict your access to the website for violating these terms or engaging in prohibited conduct.
          </Typography>

          <Typography paragraph sx={{ mt: 4 }}>
            For inquiries, contact us at{' '}
            <Typography component="span" sx={{ color: '#580100' }}>
              andhericourtsba@gmail.com
            </Typography>
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default TermsOfService;
